export default __webpack_public_path__ + "static/smartface-min-432f3b1943962c29a5ffbc1dd0054aa4.gif";